import { useMemo } from "react";
import { ISelctedRacket } from "@redux/rent/types";
import { IAvailTime } from "@pages/Services/pages/RacketRent/components/RacketRentTime/types";

export const useRacketValidation = (
  selectedRackets: { [key: string]: ISelctedRacket },
  quantity: number
) => {
  const hasUnavailableQuantity = useMemo(() => {
    return Object.values(selectedRackets).some(
      (racket) => racket.available < quantity
    );
  }, [selectedRackets, quantity]);

  const getUnavailableQuantityList = useMemo((): IAvailTime[] => {
    return Object.values(selectedRackets)
      .filter((racket) => racket.available < quantity)
      .map((racket) => ({
        time: racket.time,
        available: racket.available,
      }));
  }, [selectedRackets, quantity]);

  return {
    hasUnavailableQuantity,
    unavailableQuantityList: getUnavailableQuantityList,
  };
};

